import { render, staticRenderFns } from "./MainFooterEng.vue?vue&type=template&id=6060a3a8&scoped=true"
import script from "./MainFooterEng.vue?vue&type=script&lang=js"
export * from "./MainFooterEng.vue?vue&type=script&lang=js"
import style0 from "./MainFooterEng.vue?vue&type=style&index=0&id=6060a3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060a3a8",
  null
  
)

/* custom blocks */
import block0 from "./MainFooterEng.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImgLazy, BButton, BModal, BFormInput, BFormGroup, BForm} from 'bootstrap-vue'
    installComponents(component, {BImgLazy, BButton, BModal, BFormInput, BFormGroup, BForm})
    

export default component.exports